// formErrors.js
import { isElement, getOffset } from './utils/dom';

// this css class will be used to indicate errors
const cssErrorClass = 'js-has-error';

/**
 * Makes an error state for a form field by (1) adds a `.js-has-error` class to the control
 * (field), (2) sets the correct `.aria-labelledby` attribute on the control, (3) updates the
 * error message, (4) sets focus on the field, and (5) adds a CSS class to the element passed in
 * (optional).
 *
 * @param {HTMLElement} field The form field element
 * @param {HTMLElement} error The element that holds the error message
 * @param {string} message The error message
 * @param {HTMLElement} el Optional HTML element that can the .js-has-error class
 */
export function createError(field, error, message, el) {
  if (isElement(field)) {
    field.classList.add(cssErrorClass);

    // set focus on the first field that shows an error
    const errorElem = document.querySelector('.js-has-error');
    errorElem.focus();
    window.scrollTo(0, getOffset(errorElem).top - 120); // 120 is the height of the header + label for the input field.
  }

  if (isElement(error)) {
    // field should have aria-labelledby that contains the error element's ID
    const labelledby = field.getAttribute('aria-labelledby') || '';
    if (labelledby.indexOf(error.id) === -1) {
      field.setAttribute('aria-labelledby', `${labelledby} ${error.id}`.trim());
    }

    // update the error div text content with the message
    error.textContent = message; // eslint-disable-line no-param-reassign

    // give the error field a css class to show
    error.classList.add(cssErrorClass);
  }

  // if the option el argument was passed, add the css class
  if (isElement(el)) {
    el.classList.add(cssErrorClass);
  }
}

/**
 * Reverses the createError function by (1) removing any `.js-has-error` classes
 * and (2) removing the `.aria-labelledby` value
 * @param {HTMLElement} field The form field element
 * @param {HTMLElement} error The element that holds the error message
 * @param {HTMLElement} el Optional HTML element to remove CSS class from
 */
export function removeError(field, error, el) {
  if (isElement(field)) {
    field.classList.remove(cssErrorClass);
  }

  if (isElement(error)) {
    const labeledby = field.getAttribute('aria-labelledby') || '';
    field.setAttribute('aria-labelledby', labeledby.replace(error.id, '').trim());
    error.classList.remove(cssErrorClass);
  }

  if (isElement(el)) {
    el.classList.remove(cssErrorClass);
  }
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/formErrors.js